
export MainPage from './main/MainPage';
export LoginPage from './login/LoginPage';

export const PagePath = {
    ROOT:'/',
    LOGIN:'/login',
};